import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ResourceService } from '@teem/generic/resource.service';
import { Taxes, TaxesSerializer } from '@teem/models/taxes';
import { taxes as TaxesApi } from '@teem/constants/api';

@Injectable({
  providedIn: 'root'
})
//  ng g c features/taxes/classes/output-tax-table-schema

export class TaxService extends ResourceService<Taxes> {

  constructor(protected httpClient: HttpClient) {
    super(
      httpClient,
      TaxesApi.endPoint,
      new TaxesSerializer()
    )
  }

  public inputList(): Observable<Taxes[]> {
    return this.httpClient.get(`${TaxesApi.inputList}`, this.httpOptions)
      .pipe(map((r: any) => this.convertData(r)));
  }


  public commonData() {
    return this.httpClient.get(`${TaxesApi.common}`, this.httpOptions);
  }

}
